import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import usePolygonLegend from 'hooks/Meteorology/Fields/ModelPerformance/usePolygonLegend';
import { ModelPerformanceLegendItem } from 'types/Meteorology/Fields/ModelPerformance/mapData';

export default function PolygonLegendControl({
  legend,
  variable,
  unit,
  selectedFeatureColor = null,
  titleOverride = null,
}: {
  legend: ModelPerformanceLegendItem[];
  variable: string;
  unit: string;
  /** Cor da região selecionada; apenas o item da legenda com essa cor ganha opacidade maior. */
  selectedFeatureColor?: string | null;
  /** Substitui o título da legenda (ex.: "Precipitação para periodo livre"). */
  titleOverride?: string | null;
}) {
  const map = useMap();
  const legendControl = usePolygonLegend(legend, variable, unit, selectedFeatureColor ?? null, titleOverride ?? null); // eslint-disable-line max-len

  useEffect(() => {
    if (!map || !legendControl) return () => {};
    map.addControl(legendControl);
    return () => { map.removeControl(legendControl); };
  }, [map, legendControl]);

  return null;
}
